import { graphql } from "gatsby"
import React from "react"
import { Container } from "react-bootstrap"
import BlogPostCard from "../components/BlogPostCard"
import Layout from "../components/layout"
import Hero from "../components/Marketing/Hero"
import RealCallToActionSection from "../components/Marketing/RealCallToActionSection"
import SEO from "../components/seo"
import { ChineseText } from "../styles/global"

export const pageQuery = graphql`
  query HomePageQuery {
    allSanitySpotlight(sort: { fields: _createdAt, order: DESC }) {
      nodes {
        isLive
        id
        indexImage {
          asset {
            fluid(maxWidth: 2000) {
              ...GatsbySanityImageFluid
            }
          }
        }
        title
        slug {
          current
        }
        artist {
          englishName
          chineseName
        }
      }
    }
  }
`

const IndexPage = ({ data }) => {
  const spotlights =
    process.env.APP_ENV === "development"
      ? data.allSanitySpotlight.nodes.filter(node => node.isLive)
      : data.allSanitySpotlight.nodes
  const currentSpotlight = spotlights[0]
  const previousSpotlights = spotlights.filter((node, i) => i !== 0)

  return (
    <Layout fixedNavbar={false}>
      <SEO title="Spotlights" />
      <div className="mb-5">
        <Hero
          image={currentSpotlight.indexImage}
          heading={currentSpotlight.title}
          subheading={`${currentSpotlight.artist.englishName} ${currentSpotlight.artist.chineseName}`}
          subheadingSize="h3"
          animated
          link={`/spotlight/${currentSpotlight.slug.current}`}
          linkText="View Spotlight"
          overlineText="Current Spotlight"
        />
      </div>
      <Container>
        <h5 className="mb-3 text-center">Previous Spotlights</h5>
        {previousSpotlights.length > 0 &&
          previousSpotlights.map(spotlight => (
            <BlogPostCard
              key={spotlight.id}
              spotlight={spotlight}
              mainImage={spotlight.indexImage}
              subtitle={[
                `${spotlight.artist.englishName} `,
                <ChineseText>{spotlight.artist.chineseName}</ChineseText>,
              ]}
            />
          ))}
      </Container>
    </Layout>
  )
}

export default IndexPage
